const PERMISSIONS = 'PERMISSIONS';
const ORDER_ACCESS = 'ORDER_ACCESS';

const state = {
  permissions: null,
  orderAccess: null,
};

const getters = {
  permissions: state => state.permissions,
  orderAccess: state => state.orderAccess,
};

const actions = {
  setPermissions({dispatch, commit}, payload) {
    commit(PERMISSIONS, payload);
  },
  setOrderAccess({dispatch, commit}, payload) {
    commit(ORDER_ACCESS, payload);
  },
};

const mutations = {
  [PERMISSIONS](state, payload) {
    state.permissions = payload;
  },
  [ORDER_ACCESS](state, payload) {
    state.orderAccess = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
